<template>
  <div class="client-row">
    <v-card>
      <v-card-text class="clientEditForm client-edit-form">
        <v-container>
          <v-tabs v-model="activeSectionIndex" slider-color="primary">
            <v-tab id="tabGeneral" :value="0" ripple text="General" max-height="40" />
            <v-tab
              id="tabExcursionManagement"
              :value="1"
              ripple
              text="Excursion Management"
              max-height="40"
            />
            <v-tab id="tabProviders" :value="2" ripple text="Providers" max-height="40" />
            <v-tab id="tabContentEngine" :value="3" ripple text="Content Engine" max-height="40" />
            <v-tab
              id="tabStudentManagement"
              :value="4"
              ripple
              text="Student Management"
              max-height="40"
            />
            <v-tab id="tabTemplates" :value="5" ripple text="Templates" max-height="40" />
          </v-tabs>
          <v-tabs-window v-model="activeSectionIndex" class="px-2">
            <v-tabs-window-item :value="0">
              <div class="client-row client-modal-text">
                <client-general
                  ref="refClientGeneral"
                  :client-sid="clientSid"
                  :show-domain-conflict="subdomainConflicted"
                  @clientGeneralChanged="onClientGeneralChanged"
                  @clientLogoChanged="onClientLogoChanged"
                  @clientOptionsChanged="onClientOptionsChanged"
                  @clientGeneralSaved="onClientGeneralSaved"
                  @subdomainChanged="onSubdomainChanged"
                />
              </div>
            </v-tabs-window-item>
            <v-tabs-window-item :value="1">
              <client-excursion-management
                :client-sid="clientSid"
                :show-vendor-client-sid-conflict="vendorClientSidConflicted"
                @clientExcursionManagementChanged="onClientExcursionManagementChanged"
                @showSchoolTypeWarning="onShowSchoolTypeWarning"
                @isValidSchoolType="onIsValidSchoolType"
              />
            </v-tabs-window-item>
            <v-tabs-window-item :value="2">
              <client-provider
                :client-sid="clientSid"
                @client-provider-changed="onClientProviderChanged"
              >
              </client-provider>
            </v-tabs-window-item>
            <v-tabs-window-item :value="3">
              <client-content-engine
                ref="refClientContentEngine"
                :client-sid="clientSid"
                :subdomain="subdomain"
                :client-save-action-in-progress="clientSaveActionInProgress"
                @content-engine-changed="onClientContentEngineChanged"
                @content-engine-saved="onClientContentEngineSaved"
              >
              </client-content-engine>
            </v-tabs-window-item>
            <v-tabs-window-item :value="4">
              <client-student-management
                :client-sid="clientSid"
                :student-management-vendors="studentManagementVendors"
                :is-student-management-unchangeable="isStudentManagementUnchangeable"
                @changeStudentManagementVendorSid="changeActiveStudentManagementVendorSid"
              />
              <div v-for="(field, index) in studentManagementClientApiFields" :key="index">
                <v-row v-if="'text' === field.type" no-gutters>
                  <v-col cols="12">
                    <span>{{ field.label }}</span>
                    <span class="text-red">*</span>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :id="`txt_${field.name}`"
                      v-model="field.value"
                      variant="solo"
                      density="compact"
                      :placeholder="field.label"
                      :error-messages="field.errorMessage"
                      @update:model-value="getStudentManagementFieldErrors(field)"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="'json-textarea' === field.type" no-gutters>
                  <v-col cols="12">
                    <span>{{ field.label }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      :id="`txt_${field.name}`"
                      v-model="field.value"
                      variant="solo"
                      density="compact"
                      :placeholder="field.label"
                      :error-messages="field.errorMessage"
                      @update:model-value="getStudentManagementJsonTextareaFieldErrors(field)"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row v-if="'checkbox' === field.type" no-gutters>
                  <v-col cols="12">
                    <v-checkbox
                      :id="`tickbox_${field.name}`"
                      v-model="field.value"
                      :error-messages="field.errorMessage"
                      :label="field.label"
                      color="primary"
                      @update:model-value="isReadFromCache = false"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="'file' === field.type" no-gutters>
                  <div v-for="(file, index) in studentManagementFiles" :key="index">
                    <div v-if="!file.isDeleted">
                      <v-col cols="12" class="pa-0">
                        <label :for="getUploadFileId('studentManagement', index)">
                          <input
                            :id="getUploadFileId('studentManagement', index)"
                            style="display: none"
                            type="file"
                            :accept="studentManagementFileExtensions"
                            @change="handleStudentManagementFileChange($event, file, index)"
                          />
                        </label>
                        <cs-button
                          :id="getUploadFileBtnId('studentManagement', index)"
                          primary
                          class="excursion-stepper-upload-btn ma-0"
                          left-icon="mdi-upload"
                          label="Upload Subjects CSV"
                          @click="uploadFileClick('studentManagement', index)"
                        ></cs-button>
                      </v-col>
                      <v-col cols="12" class="px-0">
                        <span class="form-label template-file-font ma-0">File Name</span>
                      </v-col>
                      <v-col cols="12" class="pa-0">
                        {{ file.filename }}
                      </v-col>
                    </div>
                  </div>
                </v-row>
                <v-row v-if="'group-management' === field.type">
                  <v-col v-if="showStudentManagementTestConnectionBtn" cols="12">
                    <cs-button
                      id="btnTestConnection"
                      primary
                      name="btnTestConnection"
                      :disabled="studentManagementTestConnectionButtonDisabled"
                      :loading="studentManagementTestConnectionInProgress"
                      label="Test Connection"
                      class="ml-0 my-0"
                      @click="onClickStudentManagementTestConnection()"
                    ></cs-button>
                    <v-label
                      :class="
                        studentManagementTestConnectionFailedStatus.length > 0
                          ? 'generic-error-message'
                          : ''
                      "
                    >
                      {{ studentManagementTestConnectionStatusDisplay }}
                    </v-label>
                  </v-col>
                  <v-col cols="12">
                    <cs-button
                      id="btnAdminRetrieveGroupsFromVendor"
                      :primary="!isReadFromCache"
                      name="btnAdminRetrieveGroupsFromVendor"
                      :disabled="groupsLoading"
                      :loading="groupsLoading"
                      label="Retrieve Groups from Vendor"
                      class="ma-0"
                      @click="updateGroups(false)"
                    ></cs-button>
                    <cs-button
                      id="btnAdminRetrieveGroupsFromCache"
                      primary
                      :disabled="!isReadFromCache || groupsLoading"
                      :loading="groupsLoading"
                      label="Retrieve Groups from Cache"
                      class="mt-0"
                      @click="updateGroups(true)"
                    ></cs-button>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="selectedApplyParentId"
                      :items="originalGroupList"
                      item-title="group"
                      item-value="id"
                      label="Set parent for selected group"
                      clearable
                      clear-icon="mdi-close"
                      hide-details
                      single-line
                      :hide-selected="hideSelected"
                      variant="solo"
                      density="compact"
                    >
                      <template #item="data">
                        <v-list-item
                          v-bind="data.props"
                          :id="`client-individual-modal--set-parent-for-selected-group--option--${String(
                            data.item.group
                          ).replaceAll(' ', '')}`"
                        >
                          {{ data.item.group }}
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="2" class="pt-1">
                    <v-checkbox
                      id="client-individual-apply-subject-checkbox"
                      v-model="applySubjectEnabled"
                      label="Subject"
                      color="primary"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-1">
                    <v-checkbox
                      id="client-individual-apply-custom-checkbox"
                      v-model="applyCustomEnabled"
                      label="Custom"
                      color="primary"
                    />
                  </v-col>
                  <v-col cols="2">
                    <cs-button
                      id="btnApply"
                      primary
                      name="btnApply"
                      :disabled="applyButtonDisabled()"
                      label="Apply"
                      @click="applySelectedOption()"
                    />
                  </v-col>
                  <v-col v-if="studentManagementGroupSyncDiffs.length > 0" cols="12">
                    <student-group-sync-diff-alert
                      :student-group-sync-diffs="studentManagementGroupSyncDiffs"
                    />
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      id="student-management-search-input"
                      v-model="searchTerm"
                      variant="underlined"
                      density="compact"
                      color="primary"
                      clearable
                      clear-icon="mdi-close"
                      placeholder="Search Group Name"
                      @click:clear="clearSearchInput()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <cs-button
                      id="btnClientIndividualEditorSearch"
                      primary
                      name="btnStudentGroupSearch"
                      label="Search Group"
                      class="mt-0"
                      @click="filterGroups()"
                    />
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-data-table
                      v-model="selectedGroupItems"
                      :headers="groupHeaders"
                      :items="groupList"
                      :items-per-page-options="[10, 30, 50]"
                      :page="studentGroupPaginationInfo.page"
                      :items-per-page="studentGroupPaginationInfo.itemsPerPage"
                      :sort-by="studentGroupPaginationInfo.sortBy"
                      show-select
                      return-object
                      no-data-text="No group was found"
                      height="600"
                      fixed-header
                      :loading="groupsLoading"
                      @update:page="studentGroupPaginationInfo.page = $event"
                      @update:items-per-page="studentGroupPaginationInfo.itemsPerPage = $event"
                      @update:sort-by="studentGroupPaginationInfo.sortBy = $event"
                    >
                      <template
                        #[`header.data-table-select`]="{ allSelected, selectAll, someSelected }"
                      >
                        <v-checkbox-btn
                          :indeterminate="someSelected && !allSelected"
                          :model-value="allSelected"
                          color="primary"
                          @update:model-value="selectAll(!allSelected)"
                        ></v-checkbox-btn>
                      </template>
                      <template
                        #[`item.data-table-select`]="{
                          item,
                          internalItem,
                          isSelected,
                          toggleSelect
                        }"
                      >
                        <v-checkbox-btn
                          :id="getStudentManagementCheckboxId(item.group)"
                          :model-value="isSelected(internalItem)"
                          color="primary"
                          @update:model-value="toggleSelect(internalItem)"
                        ></v-checkbox-btn>
                      </template>

                      <template #[`item.group`]="{ item }">
                        {{ item.group }}
                        <span v-if="vendorGroupIdDisplayEnabled" class="studentGroupId">
                          [{{ item.id }}]</span
                        >
                      </template>

                      <template #[`item.school`]="{ item }">
                        <v-select
                          :id="getStudentManagementSchoolTypeSelectionId(item.group)"
                          v-model="item.school"
                          :items="schoolTypes"
                          clearable
                          clear-icon="mdi-close"
                          item-title="name"
                          item-value="id"
                          label="School Type"
                          variant="solo"
                          density="compact"
                          color="primary"
                          hide-details
                          single-line
                        >
                          <template #item="data">
                            <v-list-item
                              v-bind="data.props"
                              :id="`client-individual-modal--student-management--school-type--option-${String(
                                data.item.name
                              ).replaceAll(' ', '')}`"
                            >
                              {{ data.item.name }}
                            </v-list-item>
                          </template>
                        </v-select>
                      </template>
                      <template #[`item.parent`]="{ item }">
                        <v-autocomplete
                          v-if="item.parentSelectionDisplayed"
                          v-model="item.parent"
                          :items="originalGroupList"
                          label="Parent"
                          item-title="group"
                          item-value="id"
                          clearable
                          clear-icon="mdi-close"
                          hide-details
                          :hide-selected="hideSelected"
                          variant="solo"
                          density="compact"
                          @blur="parentSelected(item)"
                        >
                          <template #item="data">
                            <v-list-item
                              v-bind="data.props"
                              :id="`client-individual-modal--set-parent-for-selected-group--option--${String(
                                data.item.group
                              ).replaceAll(' ', '')}`"
                            >
                              {{ data.item.group }}
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                        <div v-else>
                          <a
                            :id="getStudentManagementParentSelectionId(item.group)"
                            class="client-individual-parent"
                            @click="displayParentSelection(item)"
                          >
                            {{
                              !item.parent
                                ? '[select]'
                                : getParentGroupName(item.parent).length === 0
                                  ? '[missing parent]'
                                  : getParentGroupName(item.parent)
                            }}
                          </a>
                          <span
                            v-if="vendorGroupIdDisplayEnabled && item.parent"
                            class="studentGroupId"
                          >
                            [{{ getParentGroupId(item.parent) }}]</span
                          >
                        </div>
                      </template>
                      <template #[`item.subjectGroup`]="{ item }">
                        <v-checkbox-btn
                          :id="getStudentManagementSubjectGroupCheckboxId(item.group)"
                          v-model="item.subjectGroup"
                          color="primary"
                        ></v-checkbox-btn>
                      </template>
                      <template #[`item.customGroup`]="{ item }">
                        <v-checkbox-btn
                          :id="getStudentManagementCustomGroupCheckboxId(item.group)"
                          v-model="item.customGroup"
                          color="primary"
                        ></v-checkbox-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-tabs-window-item>
            <v-tabs-window-item :value="5">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-icon size="small">mdi-information</v-icon>
                  <span>You can upload one file for client template.</span>
                </v-col>
                <v-col v-for="(proformaTemplateFile, index) in clientTemplateFiles" :key="index">
                  <v-row v-if="!proformaTemplateFile.isDeleted" dense>
                    <v-col cols="12">
                      <label :for="getUploadFileId('proformaTemplate', index)">
                        <input
                          :id="getUploadFileId('proformaTemplate', index)"
                          style="display: none"
                          type="file"
                          :accept="proformaTemplateFileExtensions"
                          @change="handleTemplateFileChange($event, proformaTemplateFile, index)"
                        />
                      </label>
                      <cs-button
                        :id="getUploadFileBtnId('proformaTemplate', index)"
                        primary
                        left-icon="mdi-upload"
                        label="Upload"
                        @click="uploadFileClick('proformaTemplate', index)"
                      />
                    </v-col>
                    <v-col cols="12" class="px-2">
                      <span class="form-label template-file-font">File Name</span>
                    </v-col>
                    <v-col cols="12" class="px-2">
                      <span class="form-label template-file-font">{{
                        proformaTemplateFile.filename
                      }}</span>
                      <v-icon
                        v-if="proformaTemplateFile.sid && !templateFileChanged"
                        :id="getDownloadFileBtnId('proformaTemplate', index)"
                        @click="downloadFile(proformaTemplateFile)"
                        >mdi-download
                      </v-icon>
                    </v-col>
                    <v-col cols="12" class="px-2">
                      <span class="form-label template-file-font">Uploaded Date</span>
                    </v-col>
                    <v-col cols="12" class="px-2">
                      <span class="form-label template-file-font">
                        {{ getUploadDate(proformaTemplateFile.fileUpdateDate) }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tabs-window-item>
          </v-tabs-window>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="client-individual-error">
          {{ saveActionErrorMessage }}
        </div>
        <v-spacer></v-spacer>
        <cs-button
          id="btnSave"
          primary
          label="Save All"
          :disabled="saveButtonDisabled"
          :loading="clientSaveActionInProgress"
          @click="confirmSaveDialogDisplayed = true"
        ></cs-button>
      </v-card-actions>
    </v-card>
    <cs-form-dialog
      id="dlg-client-ind-editor-invalid-file-type"
      v-model="invalidFileTypeDialogDisplayed"
      body-id="dlg-client-ind-editor-invalid-file-type-body"
      heading="Client Individual Editor"
      :primary-action="{
        label: 'OK',
        eventName: 'primary-click'
      }"
      @primary-click="invalidFileTypeDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        Invalid File type:
        <span class="debug-error-message">{{ uploadFilename }}</span>
        <br />
        <span v-safe-html="invalidFileTypeAdditionalMessage"></span>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="dlg-client-ind-editor-generic"
      v-model="genericDialogDisplayed"
      body-id="dlg-client-ind-editor-generic-body"
      heading="Client Individual Editor"
      :primary-action="{
        label: 'OK',
        eventName: 'primary-click'
      }"
      @primary-click="genericDialogOkBtnClickHandle"
    >
      <template #cs-form-dialog-content>
        <div
          v-safe-html="genericDialogMessage"
          :class="isGenericDialogDisplayedAsError ? 'generic-error-message' : ''"
        ></div>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="confirm-save-form-dialog"
      v-model="confirmSaveDialogDisplayed"
      heading="Client Settings Editor"
      :primary-action="{
        label: 'Continue',
        eventName: 'primary-click'
      }"
      @primary-click="studentManagementTestConnectionBeforeSave"
    >
      <template #cs-form-dialog-content>
        <div>
          <div v-if="studentManagementGroupSyncDiffs.length > 0">
            <student-group-sync-diff-alert
              :student-group-sync-diffs="studentManagementGroupSyncDiffs"
              :display-ignore-message="true"
            />
          </div>
          <span>You are about to save the client settings. Are you sure you want to proceed?</span>
        </div>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="confirm-test-connection-failed-dialog"
      v-model="confirmTestConnectionFailedDialogDisplayed"
      heading="Client Settings Editor"
      :primary-action="{
        label: 'Continue',
        eventName: 'primary-click'
      }"
      @primary-click="save"
    >
      <template #cs-form-dialog-content>
        <div>
          <span>
            Failed to connect to the student management vendor based on the current settings. Please
            check your configuration and try again.
          </span>
          <br /><br />
          <span>Do you still want to proceed with saving?</span>
        </div>
      </template>
    </cs-form-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import attachmentCategory from '../lib/const/attachmentCategory';
import dbEntityRelation from '../lib/const/dbEntityRelation';
import errorCaseSid from '../lib/const/errorCaseSid';
import providerSourceType from '../lib/const/providerSourceType';
import clientIndividualEditorSection from '../lib/const/clientIndividualEditorSection';
import studentGroupTableColumn from '../lib/const/studentGroupTableColumn';
import studentManagement from '../lib/studentManagement';
import ClientGeneral from './ClientGeneral';
import ClientContentEngine from './ClientContentEngine';
import ClientExcursionManagement from './ClientExcursionManagement';
import StudentGroupSyncDiffAlert from './StudentGroupSyncDiffAlert';
import ClientProvider from './ClientProvider';
import ClientStudentManagement from './ClientStudentManagement';

function validateKebabCasedString(value) {
  const regex = /^([a-z0-9]*)([-.][a-z0-9]+)*$/;
  const kebabCasedStringValid = regex.test(value);
  return kebabCasedStringValid;
}

function validateSubmomain(value) {
  if (!value || (value && value.length === 0)) {
    return true;
  }
  const regex = /^[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})*$/;
  const subdomainValid = regex.test(value);
  return subdomainValid;
}

function validateUrl(value) {
  if (!value || (value && value.length === 0)) {
    return true;
  }
  const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w-]+)+[\w\-_~:/?#[\]@!&',;=.]+$/;
  const urlValid = regex.test(value);
  return urlValid;
}

export default {
  components: {
    ClientGeneral,
    ClientExcursionManagement,
    ClientContentEngine,
    StudentGroupSyncDiffAlert,
    ClientProvider,
    ClientStudentManagement
  },

  emits: ['reloadClients'],

  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      clientName: {
        required
      },
      vendorClientSid: {
        required,
        validateKebabCasedString
      },
      timezone: {
        required
      },
      subdomain: {
        required,
        validateSubmomain
      },
      idpUrl: {
        validateIdpUrl: validateUrl
      },
      provider: {
        apiBaseUrl: {
          validateApiBaseUrl: validateUrl
        }
      }
    };
  },
  data() {
    return {
      studentManagementTestConnectionInProgress: false,
      studentManagementTestConnectionAt: '',
      studentManagementTestConnectionFailedStatus: '',
      propType: '',
      propClientSid: '',
      propClientIndividualModalRefreshed: true,
      activeSectionIndex: 0,
      excursionManagementVendorSharedSecretKey: '',
      auth0LoginEnabled: false,
      clientIndividualModalDisplayed: false,
      clientSid: '',
      clientName: '',
      csClientId: '-',
      vendorSid: null,
      vendorClientSid: '',
      vendorClientName: '',
      excursionManagementVendorWebhookUrl: '',
      clientLogoBackgroundColor: '',
      prevGetParent: 0,
      studentGroupPaginationInfo: {
        itemsPerPage: 30,
        page: 1,
        sortBy: []
      },
      isValidSchoolType: true,
      studentManagementVendors: [],
      isGenericDialogDisplayedAsError: false,
      genericDialogDisplayed: false,
      genericDialogMessage: '',
      vendorExcursionSidInputEnabled: false,
      boardingSupportEnabled: false,
      vendorClientSidConflicted: false,
      excursionAdditionalInformationEnabled: false,
      excursionChecklistEnforcementBeforeSubmissionEnabled: false,
      excursionCopyActionEnabled: false,
      excursionDestinationContentEnabled: false,
      excursionHighRiskStudentMedicalEnabled: false,
      excursionPersonResponsibleEnabled: false,
      excursionPolicyViewActionEnabled: false,
      excursionInherentRiskRatingEnabled: false,
      idpRbaclEnabled: false,
      publicSchoolFeatureSetEnabled: false,
      querystringRefToTableColumnRefMap: {},
      tableColumnRefToQuerystringRefMap: {},
      imgSrc: '',
      cropImg: '',
      logoFile: '',
      searchDomain: '',
      logoFileChanged: false,
      originalLogoUsed: true,
      contentEngine: {
        ceApiUri: '',
        xSiteUri: '',
        moduleName: ''
      },
      timezone: '',
      clientSaveActionInProgress: false,
      ceParamErrorDisplayed: false,
      subdomain: '',
      idpUrl: '',
      subdomainConflicted: false,
      activeStudentManagementVendorSid: null,
      studentManagementClientApiFields: [],
      studentManagement: {},
      newSchoolType: {},
      schoolTypes: [],
      savedSchoolTypes: [],
      groupHeaders: [
        {
          title: studentGroupTableColumn.GROUP.label,
          value: studentGroupTableColumn.GROUP.tableColumnRef,
          sortable: true,
          width: 200
        },
        {
          title: studentGroupTableColumn.SCHOOL_TYPE.label,
          value: studentGroupTableColumn.SCHOOL_TYPE.tableColumnRef,
          sortable: true,
          width: 200
        },
        {
          title: studentGroupTableColumn.PARENT.label,
          value: studentGroupTableColumn.PARENT.tableColumnRef,
          sortable: true,
          width: 200
        },
        {
          title: studentGroupTableColumn.SUBJECT_GROUP.label,
          value: studentGroupTableColumn.SUBJECT_GROUP.tableColumnRef,
          sortable: true,
          width: 110
        },
        {
          title: studentGroupTableColumn.CUSTOM_GROUP.label,
          value: studentGroupTableColumn.CUSTOM_GROUP.tableColumnRef,
          sortable: true,
          width: 110
        }
      ],
      selectedGroupItems: [],
      groupList: [],
      groupsLoading: false,
      selectedApplyParentId: null,
      applySubjectEnabled: false,
      applyCustomEnabled: false,
      clientTemplateFiles: [{}],
      invalidFileTypeDialogDisplayed: false,
      invalidFileTypeAdditionalMessage: '',
      selectedTemplateFile: {},
      proformaTemplateFileExtensions: `.pdf,.doc,.docx,.xls,.xlsx`,
      proformaTemplateFileMimeTypeAllowed: [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ],
      studentManagementFileExtensions: `.csv`,
      studentManagementFileMimeTypeAllowed: ['text/csv'],
      studentManagementFiles: [{}],
      uploadFilename: '',
      templateFileChanged: false,
      studentManagementFileChanged: false,
      isStudentManagementUnchangeable: false,
      provider: {},
      siteData: {},
      searchTerm: '',
      originalGroupList: [],
      ceParamErrorMessage: 'Invalid Content Engine parameter',
      apiProviderParamErrorMessage: 'Invalid Api Provider parameter',
      saveActionErrorMessage: '',
      studentManagementErrorHash: {},
      isClientSaved: false,
      clientStudentGroupSubsetAttributeKeys: ['sub_long', 'sub_short', 'sub_type', 'originalType'],
      invalidCredentials: `One or more of these three fields is invalid. Please confirm with the school or vendor and update. Invalid App Code / Company Code / Token Key`,
      hideSelected: false,
      studentManagementGroupSyncDiffs: [],
      confirmSaveDialogDisplayed: false,
      isReadFromCache: false,
      studentDetailsApiGroupOnlyEnabled: false,
      confirmTestConnectionFailedDialogDisplayed: false
    };
  },
  computed: {
    showStudentManagementTestConnectionBtn() {
      if (!this.activeStudentManagementVendorSid) {
        return false;
      }
      const vendorName = this.studentManagementVendors.filter(
        (item) => item.sid === this.activeStudentManagementVendorSid
      )[0]?.name;
      return vendorName === 'wonde';
    },
    studentManagementTestConnectionRequired() {
      if (!this.activeStudentManagementVendorSid) {
        return false;
      }
      const vendorName = this.studentManagementVendors.filter(
        (item) => item.sid === this.activeStudentManagementVendorSid
      )[0]?.name;
      return vendorName === 'wonde';
    },
    vendorGroupIdDisplayEnabled() {
      if (!this.activeStudentManagementVendorSid) {
        return false;
      }
      const vendorName = this.studentManagementVendors.filter(
        (item) => item.sid === this.activeStudentManagementVendorSid
      )[0]?.name;
      return vendorName === 'operoo';
    },
    vendorClientSidErrors() {
      const errors = [];
      if (this.vendorClientSidConflicted) {
        errors.push('Vendor Client SID conflicted');
      }
      return errors;
    },
    clientIndividualModalRefreshed() {
      return this.propClientIndividualModalRefreshed;
    },
    inputInvalid() {
      return this.v$.$invalid;
    },
    saveButtonDisabled() {
      let studentManagementValid = true;
      if (
        this.studentManagementClientApiFields &&
        this.studentManagementClientApiFields.length > 0
      ) {
        // TODO: Refactor this since certain text fields might not be mandatory
        const validatedFields = this.studentManagementClientApiFields.filter(
          (f) => f.type === 'text'
        );
        if (validatedFields && validatedFields.length > 0) {
          studentManagementValid = validatedFields.every((f) => f.value && `${f.value}`.length > 0);
        }
      }
      return (
        this.inputInvalid ||
        this.clientSaveActionInProgress ||
        !studentManagementValid ||
        !(
          this.contentEngine.ceApiUri &&
          this.contentEngine.xSiteUri &&
          this.contentEngine.moduleName
        ) ||
        !this.isValidSchoolType ||
        this.providerInvalid ||
        Object.keys(this.studentManagementErrorHash).length > 0
      );
    },
    providerInvalid() {
      return (
        this.provider.sourceType &&
        providerSourceType.API === this.provider.sourceType &&
        (!this.provider.apiBaseUrl ||
          !this.provider.apiKey ||
          !this.provider.apiTenantSid ||
          !this.provider.apiReportSid)
      );
    },
    subdomainErrors() {
      const errors = [];
      if (this.subdomainConflicted) {
        errors.push('Client Subdomain conflicted');
      }
      return errors;
    },
    studentManagementTestConnectionButtonDisabled() {
      const validatedFields = this.studentManagementClientApiFields.filter(
        (f) => f.type === 'text'
      );

      if (validatedFields && validatedFields.length > 0) {
        return (
          !validatedFields.every((f) => f.value && `${f.value}`.length > 0) ||
          this.studentManagementTestConnectionInProgress
        );
      }

      return true;
    },
    studentManagementTestConnectionStatusDisplay() {
      if (
        this.studentManagementTestConnectionFailedStatus.length === 0 &&
        this.studentManagementTestConnectionAt.length > 0
      ) {
        return `Last Succeed At: ${this.$app
          .moment(this.studentManagementTestConnectionAt)
          .format('YYYY-MM-DD HH:mm:ss')}.`;
      }

      if (this.studentManagementTestConnectionAt.length > 0) {
        return `Last Failed At: ${this.$app
          .moment(this.studentManagementTestConnectionAt)
          .format('YYYY-MM-DD HH:mm:ss')}. ${this.studentManagementTestConnectionFailedStatus}`;
      }

      return '';
    }
  },
  watch: {
    async clientIndividualModalRefreshed() {
      this.logoFileChanged = false;
      this.templateFileChanged = false;
      this.studentManagementFileChanged = false;
      this.clientSid = this.propClientSid;
      await this.newClient(this.propClientSid);
      this.clientIndividualModalDisplayed = true;
    },
    searchTerm() {
      this.resetStudentGroupPaginationInfo();
    },

    studentGroupPaginationInfo: {
      handler(val) {
        this.getStudentGroupFilterData(val);
      },
      deep: true
    },
    '$route.query': {
      handler(val) {
        this.updateQueryString(val);
      },
      deep: true,
      immediate: true
    },
    activeSectionIndex(val) {
      const searchQuery = {};
      searchQuery.section = this.getSectionNameByIndex(val);
      this.clearSearchInput();
      if (searchQuery.section === clientIndividualEditorSection.STUDENT_MANAGEMENT) {
        searchQuery.length = this.studentGroupPaginationInfo.itemsPerPage;
        searchQuery.page = this.studentGroupPaginationInfo.page;
      }
      if (this.studentGroupPaginationInfo.sortBy[0]) {
        searchQuery.order =
          this.tableColumnRefToQuerystringRefMap[this.studentGroupPaginationInfo.sortBy[0]?.key];
        searchQuery.direction = this.studentGroupPaginationInfo.sortBy[0]?.order?.toUpperCase();
      }
      if (
        this.groupList.length === 0 ||
        searchQuery.section !== clientIndividualEditorSection.STUDENT_MANAGEMENT
      ) {
        delete searchQuery.page;
        delete searchQuery.length;
        delete searchQuery.direction;
        delete searchQuery.order;
        this.resetPage();
      }
      this.$router.replace({ query: searchQuery }, () => {});
    }
  },
  async mounted() {
    const { params } = this.$route;
    if (params && params.id) {
      this.propClientSid = params.id;
      this.propType = 'update';
    }

    Object.keys(studentGroupTableColumn).forEach((key) => {
      this.querystringRefToTableColumnRefMap[studentGroupTableColumn[key].querystringRef] =
        studentGroupTableColumn[key].tableColumnRef;
      this.tableColumnRefToQuerystringRefMap[studentGroupTableColumn[key].tableColumnRef] =
        studentGroupTableColumn[key].querystringRef;
    });

    this.logoFileChanged = false;
    this.templateFileChanged = false;
    this.studentManagementFileChanged = false;
    const { axiosInstance, eventPluginCommonAdapter, stbApiAdapter } = this.$app;
    await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
      query: this.$route.query,
      axiosInstance
    });
    await this.$store.dispatch('common/initClientConfig', {
      eventPluginCommonAdapter,
      stbApiAdapter
    });

    const cbResponse = await this.$app.stbApiAdapter.getStudentManagementVendorList({
      store: this.$store
    });
    this.studentManagementVendors = cbResponse;
    this.logoFileChanged = false;

    this.clientSid = this.propClientSid;

    await this.newClient(this.propClientSid);
    this.clientIndividualModalDisplayed = true;

    this.updateQueryString();
    this.hideSelected = true;
  },
  methods: {
    getStudentManagementCheckboxId(group) {
      return `client-individual-modal--student-management--checkbox-${group}`;
    },
    getStudentManagementParentSelectionId(group) {
      return `client-individual-modal--student-management-parent--selection-${group}`;
    },
    getStudentManagementSubjectGroupCheckboxId(group) {
      return `client-individual-modal--student-management-subject-group--checkbox-${group}`;
    },
    getStudentManagementCustomGroupCheckboxId(group) {
      return `client-individual-modal--student-management-custom-group--checkbox-${group}`;
    },
    getStudentManagementSchoolTypeSelectionId(group) {
      return `client-individual-modal--student-management-school-type--selection-${group}`;
    },
    async newClient(clientSid) {
      this.vendorClientSidConflicted = false;
      this.subdomainConflicted = false;

      if (clientSid !== '' && undefined !== clientSid) {
        let auth0LoginEnabled = false;
        let vendorClientSid = '';
        let vendorClientName = '';
        let vendorExcursionSidInputEnabled = false;
        let boardingSupportEnabled = false;
        let excursionAdditionalInformationEnabled = false;
        let excursionChecklistEnforcementBeforeSubmissionEnabled = false;
        let excursionCopyActionEnabled = false;
        let excursionDestinationContentEnabled = false;
        let excursionHighRiskStudentMedicalEnabled = false;
        let excursionPersonResponsibleEnabled = false;
        let excursionPolicyViewActionEnabled = false;
        let excursionInherentRiskRatingEnabled = false;
        let clientLogoBackgroundColor = '';
        let provider = {};
        let excursionManagementVendorWebhookUrl = '';
        let excursionManagementVendorSharedSecretKey = '';
        let idpRbaclEnabled = false;
        let publicSchoolFeatureSetEnabled = false;

        // get logo
        const requestParam = {
          'vendor-sid': this.$store.state.common.apiParam['vendor-sid'],
          'oauth-signature': this.$store.state.common.apiParam['oauth-signature']
        };

        const argHash = {
          sid: this.clientSid,
          requestParam,
          store: this.$store
        };

        const cbResponse = await this.$app.stbApiAdapter.getClients(argHash);

        this.imgSrc = '';
        if (!cbResponse.error) {
          const client = cbResponse.data[0];

          if (client.cs_client_id) {
            this.csClientId = client.cs_client_id;
          }

          if (client.computed.logoAttachmentUrl) {
            this.cropImg = client.computed.logoAttachmentUrl;
          }

          auth0LoginEnabled = client.metadata.auth0LoginEnabled
            ? client.metadata.auth0LoginEnabled
            : false;

          const activeVendorSid = client.metadata.activeVendorSid
            ? client.metadata.activeVendorSid
            : '';

          excursionAdditionalInformationEnabled = client.metadata
            .excursionAdditionalInformationEnabled
            ? client.metadata.excursionAdditionalInformationEnabled
            : false;

          excursionChecklistEnforcementBeforeSubmissionEnabled = client.metadata
            .excursionChecklistEnforcementBeforeSubmissionEnabled
            ? client.metadata.excursionChecklistEnforcementBeforeSubmissionEnabled
            : false;

          excursionCopyActionEnabled = client.metadata.excursionCopyActionEnabled
            ? client.metadata.excursionCopyActionEnabled
            : false;

          excursionDestinationContentEnabled = client.metadata.excursionDestinationContentEnabled
            ? client.metadata.excursionDestinationContentEnabled
            : false;

          excursionHighRiskStudentMedicalEnabled = client.metadata
            .excursionHighRiskStudentMedicalEnabled
            ? client.metadata.excursionHighRiskStudentMedicalEnabled
            : false;

          excursionPolicyViewActionEnabled = client.metadata.excursionPolicyViewActionEnabled
            ? client.metadata.excursionPolicyViewActionEnabled
            : false;

          excursionInherentRiskRatingEnabled = client.metadata.excursionInherentRiskRatingEnabled
            ? client.metadata.excursionInherentRiskRatingEnabled
            : false;

          idpRbaclEnabled = client.metadata.idpRbaclEnabled
            ? client.metadata.idpRbaclEnabled
            : false;

          publicSchoolFeatureSetEnabled = client.metadata.publicSchoolFeatureSetEnabled
            ? client.metadata.publicSchoolFeatureSetEnabled
            : false;

          if (client.metadata.provider) {
            provider = client.metadata.provider;
          }

          const vendors = client[dbEntityRelation.VENDOR_LIST];
          if (activeVendorSid !== '') {
            const vendor = vendors.find((v) => v.sid === `${activeVendorSid}`);
            if (vendor) {
              if (vendor['vendor-client-sid']) {
                vendorClientSid = vendor['vendor-client-sid'];
              }

              if (vendor.join_metadata.vendorClientName) {
                vendorClientName = vendor.join_metadata.vendorClientName;
              }

              if (vendor.join_metadata.vendorExcursionSidInputEnabled) {
                vendorExcursionSidInputEnabled =
                  vendor.join_metadata.vendorExcursionSidInputEnabled;
              }

              if (vendor.join_metadata.boardingSupportEnabled) {
                boardingSupportEnabled = vendor.join_metadata.boardingSupportEnabled;
              }

              if (vendor.join_metadata.excursionPersonResponsibleEnabled) {
                excursionPersonResponsibleEnabled =
                  vendor.join_metadata.excursionPersonResponsibleEnabled;
              }

              if (vendor.join_metadata.clientLogoBackgroundColor) {
                clientLogoBackgroundColor = vendor.join_metadata.clientLogoBackgroundColor;
              }

              if (vendor.join_metadata.excursionManagementVendorWebhookUrl) {
                excursionManagementVendorWebhookUrl =
                  vendor.join_metadata.excursionManagementVendorWebhookUrl;
              }

              if (vendor.join_metadata.excursionManagementVendorSharedSecretKey) {
                excursionManagementVendorSharedSecretKey =
                  vendor.join_metadata.excursionManagementVendorSharedSecretKey;
              }
            }
          }

          this.auth0LoginEnabled = auth0LoginEnabled;
          this.clientLogoBackgroundColor = clientLogoBackgroundColor;
          this.clientName = client.metadata.name;
          this.excursionAdditionalInformationEnabled = excursionAdditionalInformationEnabled;
          this.excursionCopyActionEnabled = excursionCopyActionEnabled;
          this.excursionDestinationContentEnabled = excursionDestinationContentEnabled;
          this.excursionHighRiskStudentMedicalEnabled = excursionHighRiskStudentMedicalEnabled;
          this.excursionPersonResponsibleEnabled = excursionPersonResponsibleEnabled;
          this.excursionInherentRiskRatingEnabled = excursionInherentRiskRatingEnabled;
          this.idpRbaclEnabled = idpRbaclEnabled;
          this.publicSchoolFeatureSetEnabled = publicSchoolFeatureSetEnabled;
          this.excursionPolicyViewActionEnabled = excursionPolicyViewActionEnabled;
          this.excursionChecklistEnforcementBeforeSubmissionEnabled =
            excursionChecklistEnforcementBeforeSubmissionEnabled;
          this.provider = provider;
          this.vendorClientName = vendorClientName;
          this.vendorClientSid = vendorClientSid;
          this.vendorExcursionSidInputEnabled = vendorExcursionSidInputEnabled;
          this.boardingSupportEnabled = boardingSupportEnabled;
          this.vendorSid = client.metadata.activeVendorSid;
          this.excursionManagementVendorWebhookUrl = excursionManagementVendorWebhookUrl;
          this.excursionManagementVendorSharedSecretKey = excursionManagementVendorSharedSecretKey;
          this.activeStudentManagementVendorSid = client.metadata.activeStudentManagementVendorSid;

          if (this.activeStudentManagementVendorSid !== '') {
            const vendor = vendors.find(
              (v) => v.sid === `${this.activeStudentManagementVendorSid}`
            );
            if (vendor && vendor.join_metadata && vendor.join_metadata.studentManagement) {
              this.studentManagement = vendor.join_metadata.studentManagement;
              this.isReadFromCache = this.studentManagement.isStudentGroupListCached;
            }
          }

          if (
            this.activeStudentManagementVendorSid &&
            this.studentManagement &&
            this.studentManagement.clientApiMetadata
          ) {
            this.studentManagementClientApiFields = [];
            this.studentDetailsApiGroupOnlyEnabled =
              !!this.studentManagement.clientApiMetadata.studentDetailsApiGroupOnlyEnabled;
            const vendor = this.studentManagementVendors.find((v) => {
              return v.sid === this.activeStudentManagementVendorSid;
            });

            let clientApiMetadataSchema = {};
            if (
              vendor &&
              vendor.studentManagement &&
              vendor.studentManagement.clientApiMetadataSchema
            ) {
              clientApiMetadataSchema = vendor.studentManagement.clientApiMetadataSchema;
            }

            Object.keys(clientApiMetadataSchema).forEach((clientApiFieldKey) => {
              const clientApiField = clientApiMetadataSchema[clientApiFieldKey];
              let clientApiFieldValue = '';

              if (
                typeof this.studentManagement.clientApiMetadata[clientApiFieldKey] !== 'undefined'
              ) {
                clientApiFieldValue = this.studentManagement.clientApiMetadata[clientApiFieldKey];
              }

              const apiField = {
                name: clientApiFieldKey,
                label: clientApiField.label,
                value: clientApiFieldValue,
                type: clientApiField.type,
                groupListQueryFieldFlag: clientApiField.groupListQueryFieldFlag
              };
              this.studentManagementClientApiFields.push(apiField);
            });

            if (this.studentManagement.clientApiMetadata.groupManagement) {
              this.groupsLoading = true;
              this.groupList = [];
              const { entryHash, associationHash } =
                this.studentManagement.clientApiMetadata.groupManagement;

              if (entryHash && Object.keys(entryHash).length === 0) {
                this.isStudentManagementUnchangeable = false;
              } else {
                this.isStudentManagementUnchangeable = true;
              }

              Object.keys(entryHash).forEach((entryHashKey) => {
                const entryHashValue = entryHash[entryHashKey];
                const clientStudentGroup = {
                  id: entryHashKey,
                  group: entryHashValue.name
                };

                this.clientStudentGroupSubsetAttributeKeys.forEach((subsetAttributeKey) => {
                  const subsetAttributeValue = entryHashValue[subsetAttributeKey];

                  if (typeof subsetAttributeValue !== 'undefined') {
                    clientStudentGroup[subsetAttributeKey] = subsetAttributeValue;
                  }
                });

                switch (entryHashValue.parentType) {
                  case 'group':
                    clientStudentGroup.parent = `${entryHashValue.parentId}`;
                    break;

                  case 'school':
                    clientStudentGroup.school = `${entryHashValue.parentId}`;
                    break;

                  default:
                    break;
                }

                if (associationHash.custom && associationHash.custom[entryHashKey]) {
                  clientStudentGroup.customGroup = true;
                }

                if (associationHash.subject && associationHash.subject[entryHashKey]) {
                  clientStudentGroup.subjectGroup = true;
                }

                this.groupList.push(clientStudentGroup);
              });
              this.originalGroupList = this.$app.lodash.cloneDeep(this.groupList);
              this.groupsLoading = false;
            }

            this.studentManagementTestConnectionAt = this.studentManagement.testConnectionAt || '';
            this.studentManagementTestConnectionFailedStatus =
              this.studentManagement.testConnectionFailedStatus || '';
          } else {
            this.isStudentManagementUnchangeable = false;
          }

          this.contentEngine = {};
          if (client.metadata.contentEngine) {
            this.contentEngine = client.metadata.contentEngine;
            let { ceApiUri } = this.contentEngine;
            if (ceApiUri.substring(ceApiUri.length - 1) === '/') {
              ceApiUri = ceApiUri.substring(0, ceApiUri.lastIndexOf('/'));
            }
            this.contentEngine.ceApiUri = ceApiUri;
          }
          this.timezone = client.metadata.timezone ? client.metadata.timezone : '';
          this.subdomain = client.metadata.subdomain ? client.metadata.subdomain : '';
          this.idpUrl = client.metadata.idpUrl ? client.metadata.idpUrl : '';

          this.schoolTypes = [];
          if (client.metadata.schoolType) {
            const { schoolType } = client.metadata;
            Object.keys(schoolType).forEach((schoolKey) => {
              this.schoolTypes.push({
                id: schoolKey,
                name: schoolType[schoolKey]
              });
            });

            this.savedSchoolTypes = JSON.parse(JSON.stringify(this.schoolTypes));
          }

          // Get template file
          if (client.computed.templateAttachment) {
            const file = client.computed.templateAttachment;
            this.clientTemplateFiles[0].filename = file.metadata.filename;
            this.clientTemplateFiles[0].fileUpdateDate = file.created_at;
            this.clientTemplateFiles[0].sid = file.sid;
          }

          this.siteData = client.metadata.siteData || {};
        }
      } else {
        this.clear();
      }
    },
    constructStudentManagementGroupManagement() {
      const groupManagement = {
        entryHash: {},
        associationHash: {
          year: {},
          class: {},
          custom: {},
          subject: {}
        }
      };
      if (
        this.groupList.length !== this.originalGroupList &&
        this.searchTerm &&
        String(this.searchTerm).trim().length !== 0
      ) {
        const parsedSearchTerm = String(this.searchTerm).trim().toLowerCase();
        const leftOriginalGroupList = this.originalGroupList.filter(
          (item) => !String(item.group).toLowerCase().includes(parsedSearchTerm)
        );
        const updatedGroupList = leftOriginalGroupList.concat(this.groupList);
        updatedGroupList.forEach((clientStudentGroup) => {
          const entryId = clientStudentGroup.id;
          const entry = {
            name: clientStudentGroup.group,
            parentId: '',
            parentType: ''
          };
          groupManagement.entryHash[entryId] = entry;

          this.clientStudentGroupSubsetAttributeKeys.forEach((subsetAttributeKey) => {
            const subsetAttributeValue = clientStudentGroup[subsetAttributeKey];

            if (typeof subsetAttributeValue !== 'undefined') {
              entry[subsetAttributeKey] = subsetAttributeValue;
            }
          });

          if (clientStudentGroup.school && !clientStudentGroup.parent) {
            entry.parentId = `${clientStudentGroup.school}`;
            entry.parentType = 'school';
            groupManagement.associationHash.year[entryId] = true;
          } else if (clientStudentGroup.school && clientStudentGroup.parent) {
            delete entry.school;
            entry.parentId = `${clientStudentGroup.parent}`;
            entry.parentType = 'group';
            if (clientStudentGroup.subjectGroup) {
              groupManagement.associationHash.subject[entryId] = true;
            } else {
              groupManagement.associationHash.class[entryId] = true;
            }
          } else if (clientStudentGroup.parent) {
            entry.parentId = `${clientStudentGroup.parent}`;
            entry.parentType = 'group';
            if (clientStudentGroup.subjectGroup) {
              groupManagement.associationHash.subject[entryId] = true;
            } else {
              groupManagement.associationHash.class[entryId] = true;
            }
          } else if (clientStudentGroup.customGroup) {
            groupManagement.associationHash.custom[entryId] = true;
          }
        });
      } else {
        this.groupList.forEach((clientStudentGroup) => {
          const entryId = clientStudentGroup.id;
          const entry = {
            name: clientStudentGroup.group,
            parentId: '',
            parentType: ''
          };
          groupManagement.entryHash[entryId] = entry;

          this.clientStudentGroupSubsetAttributeKeys.forEach((subsetAttributeKey) => {
            const subsetAttributeValue = clientStudentGroup[subsetAttributeKey];

            if (typeof subsetAttributeValue !== 'undefined') {
              entry[subsetAttributeKey] = subsetAttributeValue;
            }
          });

          if (clientStudentGroup.school) {
            entry.parentId = `${clientStudentGroup.school}`;
            entry.parentType = 'school';
            groupManagement.associationHash.year[entryId] = true;
          } else if (clientStudentGroup.parent) {
            entry.parentId = `${clientStudentGroup.parent}`;
            entry.parentType = 'group';
            if (clientStudentGroup.subjectGroup) {
              groupManagement.associationHash.subject[entryId] = true;
            } else {
              groupManagement.associationHash.class[entryId] = true;
            }
          } else if (clientStudentGroup.customGroup) {
            groupManagement.associationHash.custom[entryId] = true;
          }
        });
      }
      return groupManagement;
    },
    genericDialogOkBtnClickHandle() {
      this.genericDialogDisplayed = false;
      this.isGenericDialogDisplayedAsError = false;

      if (this.isClientSaved) {
        this.clearSearchInput();
        this.$router.replace('/admin/clients').catch(() => {});
      }
    },
    async save() {
      this.confirmTestConnectionFailedDialogDisplayed = false;
      this.confirmSaveDialogDisplayed = false;
      this.vendorClientSidConflicted = false;
      this.subdomainConflicted = false;
      this.ceParamErrorDisplayed = false;
      this.saveActionErrorMessage = '';
      this.clientSaveActionInProgress = true;

      const apiParam = JSON.parse(JSON.stringify(this.$store.state.common.apiParam));

      const client = {
        auth0LoginEnabled: this.auth0LoginEnabled,
        clientLogoBackgroundColor: this.clientLogoBackgroundColor,
        contentEngine: this.contentEngine,
        excursionAdditionalInformationEnabled: this.excursionAdditionalInformationEnabled,
        excursionChecklistEnforcementBeforeSubmissionEnabled:
          this.excursionChecklistEnforcementBeforeSubmissionEnabled,
        excursionCopyActionEnabled: this.excursionCopyActionEnabled,
        excursionDestinationContentEnabled: this.excursionDestinationContentEnabled,
        excursionHighRiskStudentMedicalEnabled: this.excursionHighRiskStudentMedicalEnabled,
        excursionPersonResponsibleEnabled: this.excursionPersonResponsibleEnabled,
        excursionPolicyViewActionEnabled: this.excursionPolicyViewActionEnabled,
        excursionInherentRiskRatingEnabled: this.excursionInherentRiskRatingEnabled,
        idpRbaclEnabled: this.idpRbaclEnabled,
        publicSchoolFeatureSetEnabled: this.publicSchoolFeatureSetEnabled,
        name: this.clientName,
        provider: this.provider,
        timezone: this.timezone,
        vendorClientName: this.vendorClientName,
        vendorClientSid: this.vendorClientSid,
        vendorExcursionSidInputEnabled: this.vendorExcursionSidInputEnabled,
        boardingSupportEnabled: this.boardingSupportEnabled,
        excursionManagementVendorWebhookUrl: this.excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey: this.excursionManagementVendorSharedSecretKey,
        vendorSid: this.vendorSid,
        subdomain: this.subdomain,
        idpUrl: this.idpUrl,
        siteData: this.siteData
      };
      /*
      if (!cbGetClientIdentifiers.error) {
        client.csClientId = parsedClient.id;
      }
      */
      if (
        !client.contentEngine.ceApiUri &&
        !client.contentEngine.xSiteUri &&
        !client.contentEngine.moduleName
      ) {
        delete client.contentEngine;
      }

      if (this.activeStudentManagementVendorSid) {
        client.activeStudentManagementVendorSid = this.activeStudentManagementVendorSid;
        client.studentManagement = this.studentManagement;

        if (!client.studentManagement.clientApiMetadata) {
          client.studentManagement.clientApiMetadata = {};
        }

        if (
          this.studentManagementClientApiFields &&
          this.studentManagementClientApiFields.length > 0
        ) {
          this.studentManagementClientApiFields.forEach((f) => {
            let apiFieldsValue = '';
            if (typeof f.value !== 'undefined') {
              apiFieldsValue = f.value;
            }
            client.studentManagement.clientApiMetadata[f.name] = apiFieldsValue;
          });

          const groupManagement = this.constructStudentManagementGroupManagement();
          client.studentManagement.clientApiMetadata.groupManagement = groupManagement;
        }

        if (this.studentManagementTestConnectionRequired) {
          client.studentManagement.testConnectionFailedStatus =
            this.studentManagementTestConnectionFailedStatus;
          client.studentManagement.testConnectionAt = this.studentManagementTestConnectionAt;
        }
      }

      const schoolType = {};
      this.schoolTypes.forEach((s) => {
        schoolType[s.id] = s.name;
      });
      client.schoolType = schoolType;

      apiParam.metadata = client;

      if (apiParam.metadata.contentEngine) {
        delete apiParam.metadata.contentEngine.xAppKey;
        delete apiParam.metadata.contentEngine.xWebApiKey;
      }

      if (`${this.clientSid}` !== '') {
        if (this.templateFileChanged) {
          this.uploadClientTemplateFiles(this.clientSid);
        }
        if (this.studentManagementFileChanged) {
          const dataFromFile = await this.uploadStudentManagementFiles(this.clientSid);
          client.studentManagement = { clientApiMetadata: dataFromFile.clientApiMetadata };
          client.schoolType = dataFromFile.schoolType;
        }
        const argHash = {
          sid: this.clientSid,
          payload: apiParam,
          store: this.$store
        };

        const cbResponse = await this.$app.stbApiAdapter.putClients(argHash);
        if (cbResponse.errorDetected) {
          if (cbResponse.data && ['400', '409'].indexOf(`${cbResponse.data.statusCode}`) !== -1) {
            switch (`${cbResponse.data.errorCaseSid}`) {
              case errorCaseSid.CLIENT_SUBDOMAIN_CONFLICTED:
                this.subdomainConflicted = true;
                [this.saveActionErrorMessage] = this.subdomainErrors;
                break;

              case errorCaseSid.VENDOR_CLIENT_SID_CONFLICTED:
                this.vendorClientSidConflicted = true;
                [this.saveActionErrorMessage] = this.vendorClientSidErrors;
                break;

              case errorCaseSid.CONTENT_ENGINE_PARAMETER_INVALID:
                this.ceParamErrorDisplayed = true;
                this.saveActionErrorMessage = this.ceParamErrorMessage;
                break;

              case errorCaseSid.PROVIDER_PARAMETER_INVALID:
                this.saveActionErrorMessage = this.apiProviderParamErrorMessage;
                break;

              default:
                this.saveActionErrorMessage =
                  cbResponse.data.message || `${cbResponse.data.errorCaseSid}`;
                break;
            }
          } else {
            this.saveActionErrorMessage = cbResponse.data
              ? `${cbResponse.data.statusCode}: ${cbResponse.data.message}`
              : 'Error while saving client';
          }

          this.alertSaveResult(cbResponse);
        } else if (!cbResponse.error) {
          this.clientSid = cbResponse.data.sid;
          this.uploadClientTemplateFiles(this.clientSid);
          await this.saveLogo();
          this.alertSaveResult(cbResponse);

          this.hideSelected = false;
        } else {
          this.alertSaveResult(cbResponse);
        }
      } else {
        const apiArgHash = {
          payload: apiParam,
          store: this.$store
        };

        if (this.studentManagementFileChanged) {
          const dataFromFile = await this.uploadStudentManagementFiles(this.clientSid);
          apiArgHash.payload.metadata.studentManagement = {
            clientApiMetadata: dataFromFile.clientApiMetadata
          };
          apiArgHash.payload.metadata.schoolType = dataFromFile.schoolType;
        }

        const cbResponse = await this.$app.stbApiAdapter.postClients(apiArgHash);
        if (cbResponse.errorDetected) {
          if (cbResponse.data && ['400', '409'].indexOf(`${cbResponse.data.statusCode}`) !== -1) {
            switch (`${cbResponse.data.errorCaseSid}`) {
              case errorCaseSid.CLIENT_SUBDOMAIN_CONFLICTED:
                this.subdomainConflicted = true;
                [this.saveActionErrorMessage] = this.subdomainErrors;
                break;

              case errorCaseSid.VENDOR_CLIENT_SID_CONFLICTED:
                this.vendorClientSidConflicted = true;
                [this.saveActionErrorMessage] = this.vendorClientSidErrors;
                break;

              case errorCaseSid.CONTENT_ENGINE_PARAMETER_INVALID:
                this.ceParamErrorDisplayed = true;
                this.saveActionErrorMessage = this.ceParamErrorMessage;
                break;

              case errorCaseSid.PROVIDER_PARAMETER_INVALID:
                this.saveActionErrorMessage = this.apiProviderParamErrorMessage;
                break;

              default:
                this.saveActionErrorMessage =
                  cbResponse.data.message || `${cbResponse.data.errorCaseSid}`;
                break;
            }
          } else {
            this.saveActionErrorMessage = cbResponse.data
              ? `${cbResponse.data.statusCode}: ${cbResponse.data.message}`
              : 'Error while saving client';
          }

          this.alertSaveResult(cbResponse);
        } else if (!cbResponse.error) {
          this.clientSid = cbResponse.data.sid;
          this.uploadClientTemplateFiles(this.clientSid);

          await this.saveLogo(this.clientSid);
          this.alertSaveResult(cbResponse);

          this.hideSelected = false;
        } else {
          this.alertSaveResult(cbResponse);
        }
      }

      this.clientSaveActionInProgress = false;
    },

    async saveLogo() {
      const saveLogoRes = await this.$refs.refClientGeneral.saveLogo(this.clientSid);
      if (!saveLogoRes || saveLogoRes.error) {
        this.alertSaveResult('error', 'General Setting saved, but logo failed to be saved.');
        this.saveActionInProgress = false;
        return false;
      }
      return true;
    },

    alertSaveResult(cbResponse) {
      this.isGenericDialogDisplayedAsError = false;
      this.clientIndividualModalDisplayed = false;
      this.genericDialogDisplayed = true;

      if (cbResponse && !cbResponse.errorDetected && !cbResponse.error && cbResponse.data) {
        // success
        this.genericDialogMessage = 'Client has been saved.';
        if (
          this.groupList.length !== this.originalGroupList &&
          this.searchTerm &&
          String(this.searchTerm).trim().length !== 0
        ) {
          const parsedSearchTerm = String(this.searchTerm).trim().toLowerCase();
          const leftOriginalGroupList = this.originalGroupList.filter(
            (item) => !String(item.group).toLowerCase().includes(parsedSearchTerm)
          );
          const updatedGroupList = leftOriginalGroupList.concat(this.groupList);
          this.originalGroupList = this.$app.lodash.cloneDeep(updatedGroupList);
        }
        this.isClientSaved = true;
        this.clear();
        this.$emit('reloadClients');
      } else {
        // failed
        this.isClientSaved = false;
        this.isGenericDialogDisplayedAsError = true;
        this.genericDialogMessage = 'Failed to save Client information.';
      }
    },

    onSubdomainChanged() {
      this.subdomainConflicted = false;
      this.saveActionErrorMessage = '';
    },
    clear() {
      this.v$.$reset();
      this.auth0LoginEnabled = false;
      this.clientName = '';
      this.vendorSid = null;
      this.vendorClientSid = '';
      this.vendorClientName = '';
      this.vendorExcursionIdInputEnabled = false;
      this.excursionManagementVendorWebhookUrl = '';
      this.excursionManagementVendorSharedSecretKey = '';
      this.excursionPersonResponsibleEnabled = false;
      this.excursionAdditionalInformationEnabled = false;
      this.excursionChecklistEnforcementBeforeSubmissionEnabled = false;
      this.excursionCopyActionEnabled = false;
      this.excursionDestinationContentEnabled = false;
      this.excursionHighRiskStudentMedicalEnabled = false;
      this.excursionPolicyViewActionEnabled = false;
      this.excursionInherentRiskRatingEnabled = false;
      this.idpRbaclEnabled = false;
      this.publicSchoolFeatureSetEnabled = false;
      this.clientLogoBackgroundColor = '';
      this.contentEngine = {};
      this.timezone = '';
      this.clientSaveActionInProgress = false;
      this.ceParamErrorDisplayed = false;
      this.$store.commit(types.COMMON_RESET_PARENT_CLIENT);
      this.subdomain = '';
      this.idpUrl = '';
      this.activeStudentManagementVendorSid = null;
      this.studentManagementClientApiFields = [];
      this.isStudentManagementUnchangeable = false;
      this.vendorExcursionSidInputEnabled = false;
      this.boardingSupportEnabled = false;
      this.schoolTypes = [];
      this.savedSchoolTypes = [];
      this.isValidSchoolType = true;
      this.newSchoolType = {};
      this.groupList = [];
      this.selectedGroupItems = [];
      this.applySubjectEnabled = false;
      this.applyCustomEnabled = false;
      this.clientTemplateFiles = [{}];
      this.studentManagementFiles = [{}];
      this.provider = {};
      this.saveActionErrorMessage = '';
      this.studentManagementErrorHash = {};
      this.isReadFromCache = false;
    },

    close() {
      this.clear();
    },

    changeActiveStudentManagementVendorSid(studentManagementVendorSid) {
      this.studentManagementClientApiFields = [];
      this.activeStudentManagementVendorSid = studentManagementVendorSid;

      if (this.activeStudentManagementVendorSid) {
        this.activeStudentManagementVendorSidChanged = true;
        const vendor = this.studentManagementVendors.find(
          (v) => v.sid === this.activeStudentManagementVendorSid
        );

        if (
          vendor &&
          vendor.studentManagement &&
          vendor.studentManagement.clientApiMetadataSchema
        ) {
          const schema = vendor.studentManagement.clientApiMetadataSchema;
          Object.keys(schema).forEach((s) => {
            const field = {
              name: s,
              label: schema[s].label,
              type: schema[s].type,
              value: '',
              groupListQueryFieldFlag: schema[s].groupListQueryFieldFlag
            };
            this.studentManagementClientApiFields.push(field);
          });
        }
      }
    },
    getStudentManagementFieldErrors(field) {
      this.isReadFromCache = false;
      const localField = field;
      const errors = [];

      if (
        field.label === 'App Code' ||
        field.label === 'Token Key' ||
        field.label === 'Company Code'
      ) {
        const tokenKeyField = this.studentManagementClientApiFields.filter(
          (item) => item.label === 'Token Key'
        );
        if (
          tokenKeyField.length > 0 &&
          JSON.stringify(tokenKeyField[0].errorMessage)?.includes(this.invalidCredentials)
        ) {
          tokenKeyField[0].errorMessage = [];
        }
      }

      if (!field.value || (field.value && field.value.length === 0)) {
        errors.push(`${field.label} is required`);
      }
      localField.errorMessage = errors;
      this.$forceUpdate();
    },
    getStudentManagementJsonTextareaFieldErrors(field) {
      this.isReadFromCache = false;
      const localField = field;
      const errors = [];
      const fieldName = field.name;
      const fieldValue = field.value;

      if (typeof fieldValue !== 'undefined' && `${fieldValue}` !== '') {
        let parsedJson;

        try {
          parsedJson = JSON.parse(fieldValue);
        } catch (_err) {
          errors.push(`${field.label} needs to be a valid JSON`);
        }

        if (parsedJson) {
          const parsedJsonKeys = Object.keys(parsedJson);

          if (parsedJsonKeys.length <= 0) {
            errors.push(`${field.label} needs to be a non-empty JSON`);
          }
        }
      }

      const clonedStudentManagementErrorHash = JSON.parse(
        JSON.stringify(this.studentManagementErrorHash)
      );

      if (errors.length > 0) {
        clonedStudentManagementErrorHash[fieldName] = true;
      } else {
        delete clonedStudentManagementErrorHash[fieldName];
      }

      if (
        clonedStudentManagementErrorHash[fieldName] !== this.studentManagementErrorHash[fieldName]
      ) {
        // Reassign this variable to force recalculation of saveButtonDisabled
        this.studentManagementErrorHash = clonedStudentManagementErrorHash;
      }

      localField.errorMessage = errors;
      this.$forceUpdate();
    },
    async updateGroups(readFromCache) {
      this.clearSearchInput();
      const vendor = this.studentManagementVendors.find(
        (v) => v.sid === this.activeStudentManagementVendorSid
      );
      const studentVendorParams = {
        'module-name': vendor.module_name,
        readFromCache
      };
      this.studentManagementClientApiFields.forEach((clientApiField) => {
        if (clientApiField.groupListQueryFieldFlag) {
          if (clientApiField.type === 'checkbox') {
            if (clientApiField.value) {
              studentVendorParams[clientApiField.name] = true;
            }
          } else {
            studentVendorParams[clientApiField.name] = clientApiField.value;
          }
        }
      });

      this.groupsLoading = true;
      const argHash = {
        studentVendorParams,
        store: this.$store
      };
      const cbResponse = await this.$app.stbApiAdapter.getClientStudentGroupList(argHash);

      const apiAuthListField = this.studentManagementClientApiFields.filter(
        (item) => item.label === 'API Auth List'
      )[0];
      this.groupsLoading = false;

      if (!cbResponse.error) {
        this.isReadFromCache = true;
        const remoteGroupList = cbResponse.data;
        const existingGroupList = JSON.parse(JSON.stringify(this.groupList));
        const existingGroupManagement = {
          ...this.studentManagement?.clientApiMetadata?.groupManagement
        };

        this.studentManagementGroupSyncDiffs = studentManagement.getGroupSyncDiffs(
          existingGroupManagement,
          remoteGroupList
        );

        this.groupList = remoteGroupList.map((remoteGroup) => {
          const existingGroup = existingGroupList.find((s) => `${s.id}` === `${remoteGroup.id}`);

          if (existingGroup && existingGroup.group !== remoteGroup.name) {
            existingGroup.group = remoteGroup.name;
          }

          const resolvedGroup = existingGroup
            ? JSON.parse(JSON.stringify(existingGroup))
            : {
                id: remoteGroup.id,
                group: remoteGroup.name
              };

          this.clientStudentGroupSubsetAttributeKeys.forEach((subsetAttributeKey) => {
            const subsetAttributeValue = remoteGroup[subsetAttributeKey];

            if (typeof subsetAttributeValue !== 'undefined') {
              resolvedGroup[subsetAttributeKey] = subsetAttributeValue;
            }
          });
          return resolvedGroup;
        });

        this.originalGroupList = this.$app.lodash.cloneDeep(this.groupList);
      } else if (errorCaseSid.VENDOR_TOKEN_KEY_INVALID === `${cbResponse.errorCaseSid}`) {
        const apiEndpointField = this.studentManagementClientApiFields.filter(
          (item) => item.label === 'Token Key'
        )[0];
        const errors = [];
        errors.push(`Invalid Token Key`);
        if (this.studentDetailsApiGroupOnlyEnabled) {
          apiAuthListField.errorMessage = errors;
        } else {
          apiEndpointField.errorMessage = errors;
        }
        document.getElementsByClassName('clientEditForm')[0].scrollTop = 200;
        this.$forceUpdate();
      } else if (errorCaseSid.VENDOR_API_CREDENTIALS_INVALID === `${cbResponse.errorCaseSid}`) {
        const tokenKeyField = this.studentManagementClientApiFields.filter(
          (item) => item.label === 'Token Key'
        )[0];
        const errors = [];
        errors.push(this.invalidCredentials);
        if (this.studentDetailsApiGroupOnlyEnabled) {
          apiAuthListField.errorMessage = errors;
        } else {
          tokenKeyField.errorMessage = errors;
        }
        document.getElementsByClassName('clientEditForm')[0].scrollTop = 200;
        this.$forceUpdate();
      } else if (errorCaseSid.VENDOR_API_KEY_INVALID === `${cbResponse.errorCaseSid}`) {
        const apiKeyField = this.studentManagementClientApiFields.filter(
          (item) => item.label === 'API Key'
        )[0];
        const errors = [];
        errors.push(`Invalid API key`);
        apiKeyField.errorMessage = errors;
        this.$forceUpdate();
      } else if (errorCaseSid.VENDOR_ORGANIZATION_ID_INVALID === `${cbResponse.errorCaseSid}`) {
        const organizationIdField = this.studentManagementClientApiFields.filter(
          (item) => item.label === 'Organization ID'
        )[0];
        const errors = [];
        errors.push(`Invalid Organization ID`);
        organizationIdField.errorMessage = errors;
        this.$forceUpdate();
      } else if (errorCaseSid.VENDOR_API_ENDPOINT_INVALID === `${cbResponse.errorCaseSid}`) {
        const apiEndpointField = this.studentManagementClientApiFields.filter(
          (item) => item.label === 'API Endpoint'
        )[0];
        const errors = [];
        errors.push(`Invalid API Endpoint`);
        if (this.studentDetailsApiGroupOnlyEnabled) {
          apiAuthListField.errorMessage = errors;
        } else {
          apiEndpointField.errorMessage = errors;
        }
        document.getElementsByClassName('clientEditForm')[0].scrollTop = 0;
        this.$forceUpdate();
      } else {
        this.$store.commit(types.COMMON_SET_IS_RESPONSE_WITH_ERROR, false);

        this.genericDialogDisplayed = true;
        this.isGenericDialogDisplayedAsError = true;
        this.genericDialogMessage = cbResponse.message.replace(
          /: ses/,
          '<br/><br/>Sentinel Event ID: ses'
        );
      }
    },
    parentSelected(item) {
      const localItem = item;
      localItem.parentSelectionDisplayed = false;
      this.$forceUpdate();
    },
    getParentGroupName(parentId) {
      const parentGroup = this.originalGroupList.find((g) => `${g.id}` === `${parentId}`);
      return parentGroup ? parentGroup.group : '';
    },
    getParentGroupId(parentId) {
      const parentGroup = this.originalGroupList.find((g) => `${g.id}` === `${parentId}`);
      return parentGroup ? parentGroup.id : '';
    },
    displayParentSelection(item) {
      /* eslint-disable no-param-reassign */
      this.groupList.forEach((g) => {
        g.parentSelectionDisplayed = false;
        if (g.id === item.id) {
          g.parentSelectionDisplayed = true;
        }
      });
      /* eslint-enable no-param-reassign */
      this.groupList = this.$app.lodash.cloneDeep(this.groupList);
      this.$forceUpdate();
    },
    applyButtonDisabled() {
      return !this.selectedGroupItems || this.selectedGroupItems.length === 0;
    },
    applySelectedOption() {
      const { selectedApplyParentId } = this;
      if (this.selectedGroupItems && this.selectedGroupItems.length > 0) {
        this.selectedGroupItems.forEach((group) => {
          const localGroup = group;
          if (this.applySubjectEnabled) {
            localGroup.subjectGroup = true;
          }
          if (this.applyCustomEnabled) {
            localGroup.customGroup = true;
          }
          localGroup.parent = selectedApplyParentId;
        });
      }
      this.selectedGroupItems = [];
      this.selectedApplyParentId = null;
      this.applySubjectEnabled = false;
      this.applyCustomEnabled = false;
      this.$forceUpdate();
    },
    getUploadFileId(category, index) {
      return `uploadFile__${category}__${index}`;
    },
    getUploadFileBtnId(category, index) {
      return `uploadFileBtn__${category}__${index}`;
    },
    getDownloadFileBtnId(category, index) {
      return `downloadFileBtn__${category}__${index}`;
    },
    uploadFileClick(category, index) {
      document.getElementById(`uploadFile__${category}__${index}`).click();
    },
    getUploadDate(uploadDate) {
      let timezoneDate = '';
      if (uploadDate) {
        const localDate = this.$app.moment(uploadDate);
        timezoneDate = this.$app
          .moment(localDate)
          .utc()
          .tz(this.$store.state.common.clientTimezone)
          .format('DD/MM/YYYY, hh:mm:ss A');
      }
      return timezoneDate;
    },
    handleTemplateFileChange(e, proformaTemplateFile) {
      if (e && e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        const filename = file.name;
        const fileType = file.type;
        const extensionType = filename.split('.').pop();

        if (
          this.proformaTemplateFileExtensions.indexOf(extensionType) < 0 ||
          !this.proformaTemplateFileMimeTypeAllowed.includes(fileType)
        ) {
          this.invalidFileTypeDialogDisplayed = true;
          this.uploadFilename = filename;
          e.target.value = '';
          this.invalidFileTypeAdditionalMessage = '';
          return;
        }

        // eslint-disable-next-line no-param-reassign
        proformaTemplateFile.file = file;
        // eslint-disable-next-line no-param-reassign
        proformaTemplateFile.filename = file.name;
        // eslint-disable-next-line no-param-reassign
        proformaTemplateFile.fileUpdateDate = '';
        this.$forceUpdate();
        this.templateFileChanged = true;
      }
    },
    handleStudentManagementFileChange(e, studentManagementFile) {
      if (e && e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        const filename = file.name;
        const fileType = file.type;
        const extensionType = filename.split('.').pop();

        if (
          this.studentManagementFileExtensions.indexOf(extensionType) < 0 ||
          !this.studentManagementFileMimeTypeAllowed.includes(fileType)
        ) {
          this.invalidFileTypeDialogDisplayed = true;
          this.invalidFileTypeAdditionalMessage = `Please select a <span class="debug-error-message">csv</span> file.`;
          this.uploadFilename = filename;
          e.target.value = '';
          return;
        }

        // eslint-disable-next-line no-param-reassign
        studentManagementFile.file = file;
        // eslint-disable-next-line no-param-reassign
        studentManagementFile.filename = file.name;
        this.$forceUpdate();
        this.studentManagementFileChanged = true;
      }
    },
    async downloadFile(proformaTemplateFile) {
      const apiQuery = JSON.parse(JSON.stringify(this.$store.state.common.apiParam));

      const argHash = {
        queryParam: apiQuery,
        sid: proformaTemplateFile.sid,
        store: this.$store
      };
      const response = await this.$app.stbApiAdapter.getAttachments(argHash);
      if (response.data) {
        const attachments = response.data;
        if (attachments.length > 0) {
          const file = attachments[0];
          if (file && file.computed && file.metadata) {
            const filePath = file.computed.url.replace(/^\//, '');
            const apiUrl = this.$app.env.API_URL.replace(/\/$/, '');
            const fileUrl = `${apiUrl}/${filePath}`;
            const { filename } = file.metadata;
            const excursionCommonAdapter = new this.$app.excursionCommon.Adapter({
              store: this.$store,
              app: this.$app
            });
            excursionCommonAdapter.downloadFile(fileUrl, filename, this.$app.deviceDetector);
          }
        }
      }
    },
    async uploadClientTemplateFiles() {
      if (this.clientTemplateFiles && this.clientTemplateFiles.length > 0) {
        const fd = new FormData();
        fd.append('category', attachmentCategory.PROFORMA_TEMPLATE);
        const addTemplateFilesList = this.clientTemplateFiles.filter(
          (a) => typeof a.file !== 'undefined'
        );
        if (addTemplateFilesList && addTemplateFilesList.length > 0) {
          for (let i = 0; i < addTemplateFilesList.length; i += 1) {
            const proformaTemplateFile = addTemplateFilesList[i];
            fd.append('file', proformaTemplateFile.file);
          }
          const argHash = {
            sid: this.clientSid,
            payload: fd,
            store: this.$store
          };
          await this.$app.stbApiAdapter.postClientAttachmentCategories(argHash);
        }
      }
    },
    async uploadStudentManagementFiles() {
      let clientApiMetadata = {};
      if (this.studentManagementFiles && this.studentManagementFiles.length > 0) {
        const fd = new FormData();
        fd.append('category', attachmentCategory.STUDENT_MANAGEMENT);
        const addStudentManagementFilesList = this.studentManagementFiles.filter(
          (a) => typeof a.file !== 'undefined'
        );
        if (addStudentManagementFilesList && addStudentManagementFilesList.length > 0) {
          for (let i = 0; i < addStudentManagementFilesList.length; i += 1) {
            const studentManagementFile = addStudentManagementFilesList[i];
            fd.append('file', studentManagementFile.file);
          }
          const argHash = {
            payload: fd,
            store: this.$store
          };
          clientApiMetadata =
            await this.$app.stbApiAdapter.postClientSubjectImportPreviews(argHash);
        }
      }
      return clientApiMetadata;
    },
    getStudentGroupFilterData(paginationOptions) {
      const parsedSection = this.getSectionNameByIndex(this.activeSectionIndex);
      const searchQuery = {
        section: parsedSection,
        page: paginationOptions.page,
        length: paginationOptions.itemsPerPage
      };
      if (paginationOptions.sortBy[0]) {
        searchQuery.order =
          this.tableColumnRefToQuerystringRefMap[paginationOptions.sortBy[0]?.key];
        searchQuery.direction = paginationOptions.sortBy[0]?.order?.toUpperCase();
      }
      if (clientIndividualEditorSection.STUDENT_MANAGEMENT === parsedSection) {
        if (this.groupList.length === 0) {
          delete searchQuery.page;
          delete searchQuery.length;
          delete searchQuery.direction;
          delete searchQuery.order;
        }
        if (this.searchTerm && String(this.searchTerm).trim().length !== 0) {
          searchQuery.s = String(this.searchTerm).trim().toLocaleLowerCase();
        }
        this.$router.replace({ query: searchQuery }, () => {});
      }
    },
    resetPage() {
      this.studentGroupPaginationInfo.itemsPerPage = 30;
      this.studentGroupPaginationInfo.page = 1;
      this.studentGroupPaginationInfo.sortBy = [];
    },
    getSectionNameByIndex(index) {
      switch (index) {
        case 0:
          return clientIndividualEditorSection.GENERAL;
        case 1:
          return clientIndividualEditorSection.EXCURSION_MANAGEMENT;
        case 2:
          return clientIndividualEditorSection.PROVIDERS;
        case 3:
          return clientIndividualEditorSection.CONTENT_ENGINE;
        case 4:
          return clientIndividualEditorSection.STUDENT_MANAGEMENT;
        case 5:
          return clientIndividualEditorSection.TEMPLATES;
        default:
          return clientIndividualEditorSection.GENERAL;
      }
    },
    updateQueryString(query) {
      if (query) {
        this.$router.replace({ query }, () => {});
        return;
      }
      const searchQuery = {};
      searchQuery.section = clientIndividualEditorSection.GENERAL;
      if (Object.keys(this.$route.query).length !== 0) {
        const {
          section: parsedSection,
          page: parsedPage,
          length: parsedLength,
          direction: parsedDirection,
          order: parsedSortBy,
          s: parsedSearchGroup
        } = this.$route.query;

        if (parsedSection && String(parsedSection).trim().length !== 0) {
          switch (parsedSection) {
            case clientIndividualEditorSection.GENERAL:
              this.activeSectionIndex = 0;
              break;
            case clientIndividualEditorSection.EXCURSION_MANAGEMENT:
              searchQuery.section = clientIndividualEditorSection.EXCURSION_MANAGEMENT;
              this.activeSectionIndex = 1;
              break;
            case clientIndividualEditorSection.PROVIDERS:
              searchQuery.section = clientIndividualEditorSection.PROVIDERS;
              this.activeSectionIndex = 2;
              break;
            case clientIndividualEditorSection.CONTENT_ENGINE:
              searchQuery.section = clientIndividualEditorSection.CONTENT_ENGINE;
              this.activeSectionIndex = 3;
              break;
            case clientIndividualEditorSection.STUDENT_MANAGEMENT:
              searchQuery.section = clientIndividualEditorSection.STUDENT_MANAGEMENT;
              this.activeSectionIndex = 4;
              if (parsedLength === '10' || parsedLength === '30' || parsedLength === '50') {
                this.studentGroupPaginationInfo.itemsPerPage = parseInt(parsedLength, 10);
                searchQuery.length = parseInt(parsedLength, 10);
              } else {
                this.studentGroupPaginationInfo.itemsPerPage = 30;
                searchQuery.length = 30;
              }

              if (!Number.isNaN(parseInt(parsedPage, 10)) && parseInt(parsedPage, 10) > 0) {
                this.studentGroupPaginationInfo.page = parseInt(parsedPage, 10);
                searchQuery.page = parseInt(parsedPage, 10);
              }

              if (
                studentGroupTableColumn.GROUP.querystringRef === parsedSortBy ||
                studentGroupTableColumn.SCHOOL_TYPE.querystringRef === parsedSortBy ||
                studentGroupTableColumn.PARENT.querystringRef === parsedSortBy ||
                studentGroupTableColumn.SUBJECT_GROUP.querystringRef === parsedSortBy ||
                studentGroupTableColumn.CUSTOM_GROUP.querystringRef === parsedSortBy
              ) {
                this.studentGroupPaginationInfo.sortBy[0] = {
                  key: this.querystringRefToTableColumnRefMap[parsedSortBy]
                };

                searchQuery.order = parsedSortBy;
                if (parsedDirection === 'DESC' || parsedDirection === 'ASC') {
                  this.studentGroupPaginationInfo.sortBy[0].order = parsedDirection;
                  searchQuery.direction = parsedDirection;
                } else {
                  this.studentGroupPaginationInfo.sortBy[0].order = 'ASC';
                  searchQuery.direction = 'ASC';
                }
              }

              if (parsedSearchGroup && String(parsedSearchGroup).trim().length !== 0) {
                this.searchTerm = String(parsedSearchGroup).trim().toLowerCase();
                searchQuery.s = this.searchTerm;
                this.groupList = this.originalGroupList.filter((item) =>
                  String(item.group).toLowerCase().includes(this.searchTerm)
                );
                this.groupList = this.$app.lodash.cloneDeep(this.groupList);
                this.$forceUpdate();
              }
              break;
            case clientIndividualEditorSection.TEMPLATES:
              searchQuery.section = clientIndividualEditorSection.TEMPLATES;
              this.activeSectionIndex = 5;
              break;
            default:
              this.activeSectionIndex = 0;
          }
        }
      }

      this.$router.replace({ query: searchQuery }, () => {});
    },

    filterGroups() {
      this.resetStudentGroupPaginationInfo();
      const { query } = this.$route;
      const searchQuery = this.$app.lodash.cloneDeep(query);
      const parsedSearchTerm = String(this.searchTerm).trim().toLowerCase();
      if (this.searchTerm && parsedSearchTerm.length !== 0) {
        searchQuery.s = parsedSearchTerm;
        this.groupList = this.originalGroupList.filter((item) =>
          String(item.group).toLowerCase().includes(parsedSearchTerm)
        );
        this.groupList = this.$app.lodash.cloneDeep(this.groupList);
        this.$forceUpdate();
        this.updateQueryString(searchQuery);
      } else {
        this.clearSearchInput();
      }
    },
    clearSearchInput() {
      this.searchTerm = '';
      this.groupList = this.$app.lodash.cloneDeep(this.originalGroupList);
      this.$forceUpdate();
    },
    resetStudentGroupPaginationInfo() {
      this.studentGroupPaginationInfo = {
        itemsPerPage: 30,
        page: 1,
        sortBy: []
      };
    },
    async studentManagementTestConnection() {
      const currentVendor = this.studentManagementVendors.find(
        (vendor) => vendor.sid === this.activeStudentManagementVendorSid
      );

      const studentVendorParams = {
        studenVendor: currentVendor.module_name
      };

      this.studentManagementClientApiFields.forEach((apiField) => {
        const apiFieldValue = (() => {
          if (apiField.type === 'checkbox') {
            if (apiField.value) {
              return true;
            }

            return false;
          }

          return typeof apiField.value !== 'undefined' ? apiField.value : '';
        })();

        studentVendorParams[apiField.name] = apiFieldValue;
      });

      const result = await this.$app.stbApiAdapter.getClientStudentTestConnection(
        studentVendorParams.studenVendor,
        studentVendorParams.apiEndpoint,
        studentVendorParams.tokenKey,
        studentVendorParams.schoolId
      );

      return result;
    },
    async onClickStudentManagementTestConnection() {
      this.studentManagementTestConnectionInProgress = true;

      const result = await this.studentManagementTestConnection();

      this.$store.commit(types.COMMON_SET_IS_RESPONSE_WITH_ERROR, false);
      this.studentManagementTestConnectionInProgress = false;
      this.genericDialogDisplayed = true;

      if (!result.error) {
        this.studentManagementTestConnectionAt = result.data.connectionTestedAt;
        this.studentManagementTestConnectionFailedStatus = '';
        this.isGenericDialogDisplayedAsError = false;
        this.genericDialogMessage = [
          `Successfully connect with student management vendor for school "${result.data.schoolName}".`,
          '<br/><br/>',
          'Please click "Save" to save the current settings.'
        ].join('');
      } else {
        this.studentManagementTestConnectionAt = this.$app.moment().toISOString();
        this.studentManagementTestConnectionFailedStatus = result.message;
        this.isGenericDialogDisplayedAsError = true;
        this.genericDialogMessage = result.message;
      }
    },
    async studentManagementTestConnectionBeforeSave() {
      if (!this.studentManagementTestConnectionRequired) {
        this.save();
        return;
      }

      this.confirmTestConnectionFailedDialogDisplayed = false;
      this.confirmSaveDialogDisplayed = false;
      this.vendorClientSidConflicted = false;
      this.subdomainConflicted = false;
      this.ceParamErrorDisplayed = false;
      this.saveActionErrorMessage = '';
      // this.cropButtonDisabled = true;
      this.clientSaveActionInProgress = true;

      const result = await this.studentManagementTestConnection();

      this.$store.commit(types.COMMON_SET_IS_RESPONSE_WITH_ERROR, false);

      if (!result.error) {
        this.studentManagementTestConnectionAt = result.data.connectionTestedAt;
        this.studentManagementTestConnectionFailedStatus = '';
        this.save();
      } else {
        this.studentManagementTestConnectionAt = this.$app.moment().toISOString();
        this.studentManagementTestConnectionFailedStatus = result.message;
        this.confirmTestConnectionFailedDialogDisplayed = true;
        this.clientSaveActionInProgress = false;
      }
    },
    onClientGeneralChanged(clientGeneralData) {
      if (!clientGeneralData) {
        return;
      }
      const { clientName, subdomain, idpUrl, timezone } = clientGeneralData;
      this.clientName = clientName;
      this.timezone = timezone;
      this.idpUrl = idpUrl;
      this.subdomain = subdomain;
    },
    onClientLogoChanged(clientLogo) {
      if (!clientLogo) {
        return;
      }
      const { clientLogoBackgroundColor } = clientLogo;
      this.clientLogoBackgroundColor = clientLogoBackgroundColor;
    },
    onClientOptionsChanged(clientOptions) {
      const {
        excursionAdditionalInformationEnabled,
        auth0LoginEnabled,
        excursionCopyActionEnabled,
        excursionChecklistEnforcementBeforeSubmissionEnabled,
        excursionHighRiskStudentMedicalEnabled,
        excursionPersonResponsibleEnabled,
        excursionPolicyViewActionEnabled,
        excursionInherentRiskRatingEnabled,
        idpRbaclEnabled,
        publicSchoolFeatureSetEnabled
      } = clientOptions;

      this.auth0LoginEnabled = auth0LoginEnabled;
      this.excursionAdditionalInformationEnabled = excursionAdditionalInformationEnabled;
      this.excursionChecklistEnforcementBeforeSubmissionEnabled =
        excursionChecklistEnforcementBeforeSubmissionEnabled;
      this.excursionCopyActionEnabled = excursionCopyActionEnabled;

      this.excursionHighRiskStudentMedicalEnabled = excursionHighRiskStudentMedicalEnabled;
      this.excursionPersonResponsibleEnabled = excursionPersonResponsibleEnabled;

      this.excursionPolicyViewActionEnabled = excursionPolicyViewActionEnabled;
      this.excursionInherentRiskRatingEnabled = excursionInherentRiskRatingEnabled;
      this.idpRbaclEnabled = idpRbaclEnabled;
      this.publicSchoolFeatureSetEnabled = publicSchoolFeatureSetEnabled;
    },
    onClientGeneralSaved() {
      // go to Excursion Management section
      this.activeSectionIndex = 2;
    },
    onClientContentEngineChanged(contentEngine) {
      const { ceApiUri, xSiteUri, moduleName } = contentEngine;
      this.contentEngine = { ceApiUri, xSiteUri, moduleName };
    },
    onClientContentEngineSaved() {
      // go to Student Management section
      this.activeSectionIndex = 5;
    },
    onClientExcursionManagementChanged(excursionManagement) {
      const {
        vendorSid,
        vendorClientSid,
        vendorClientName,
        excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey,
        vendorExcursionSidInputEnabled,
        boardingSupportEnabled,
        schoolTypes
      } = excursionManagement;
      this.vendorSid = vendorSid;
      this.vendorClientSid = vendorClientSid;
      this.vendorClientName = vendorClientName;
      this.excursionManagementVendorWebhookUrl = excursionManagementVendorWebhookUrl;
      this.excursionManagementVendorSharedSecretKey = excursionManagementVendorSharedSecretKey;
      this.vendorExcursionSidInputEnabled = vendorExcursionSidInputEnabled;
      this.boardingSupportEnabled = boardingSupportEnabled;
      this.schoolTypes = schoolTypes;
    },
    onShowSchoolTypeWarning() {
      this.genericDialogDisplayed = true;
      this.isGenericDialogDisplayedAsError = true;
      this.genericDialogMessage = 'Doing school type changes may cause issues in PlanCheckGo!';
    },
    onIsValidSchoolType(isValidSchoolType) {
      this.isValidSchoolType = isValidSchoolType;
    },
    onClientProviderChanged(provider) {
      const { sourceType, clientApiProvider, clientSftpProvider } = provider;
      if (sourceType === providerSourceType.API) {
        const {
          baseUrl: apiBaseUrl,
          tenantSid: apiTenantSid,
          apiKey,
          reportSid: apiReportSid
        } = clientApiProvider;
        this.provider = { sourceType, apiBaseUrl, apiTenantSid, apiKey, apiReportSid };
      } else if (sourceType === providerSourceType.SFTP) {
        const { sftpPath } = clientSftpProvider;
        this.provider = { sourceType, sftpPath };
      } else {
        this.provider = {};
      }
    }
  }
};
</script>
<style scoped>
.client-edit-form {
  min-height: 70vh;
}

.buildIndexContainer {
  display: flex;
  align-items: center;
  color: green;
}

.noIndexBuild {
  color: red;
}

.studentGroupId {
  color: gray;
}

.generic-error-message {
  color: rgb(var(--v-theme-error));
}

.client-individual-parent {
  color: #c80063 !important;
}

.client-individual-error {
  color: #ff0000;
  padding-left: 32px;
}
</style>
